import { Component, computed, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TextTruncationService } from '../../../core/services/text-truncation/text-truncation.service';
import { SafeHtmlPipe } from 'src/app/shared/pipes/safe-html.pipe';

// TODO confirm this length
const MAX_CHARACTERS_TO_SHOW = 1000;

@Component({
  standalone: true,
  selector: 'base-description',
  templateUrl: './description.component.html',
  styleUrls: ['./description.component.scss'],
  imports: [
    CommonModule,
    SafeHtmlPipe
  ]
})
export class DescriptionComponent {
  private textTruncationService = inject(TextTruncationService);

  MAX_CHARACTERS_TO_SHOW = MAX_CHARACTERS_TO_SHOW;

  readonly description = input<string>('');
  private _isExpanded = signal(false);

  readonly truncatedResult = computed(() => {
    return this.textTruncationService.truncateText(
      this.description(),
      MAX_CHARACTERS_TO_SHOW,
      this._isExpanded()
    );
  });

  toggleViewMoreComments() {
    this._isExpanded.set(!this._isExpanded());
  }

  get isExpanded() {
    return this._isExpanded();
  }
}

